module.exports = __webpack_public_path__ + "img/view_device_c6_en.7a1e21ff.png";